<template>
  <div>
    <div class="d-flex justify-content-between align-content-center border-bottom">
      <h3 class="text-muted font-weight-bold mb-2">اضافة الأوراق المطلوبة</h3>
    </div>
    <ValidationObserver ref="requiredDocForm" v-slot="{ handleSubmit, invalid }">
      <b-form class="position-relative form-top" @submit.prevent="handleSubmit(onSubmit)">
        <input-form
          label="الاسم (العربية)"
          name="الاسم بالعربية"
          vid="modal-required-doc-name-ar"
          placeholder="أدخل الاسم بالعربية"
          v-model="nameAr"
          validate="arabic_name"
        />
        <input-form
          label="الاسم (الإنجليزية)"
          name="الاسم بالإنجليزية"
          vid="modal-required-doc-name-en"
          placeholder="Enter name in English"
          v-model="nameEn"
          validate="english_name"
        />
        <b-form-group label-cols-md="12" label="نشط" label-for="modal-required-doc-active-yes">
          <div class="d-flex align-items-center flex-wrap required-doc-active-row">
            <b-form-radio
              id="modal-required-doc-active-yes"
              v-model="status"
              class="mb-2"
              name="modal-required-doc-active"
              value="1"
            >
              نعم
            </b-form-radio>
            <b-form-radio
              id="modal-required-doc-active-no"
              v-model="status"
              class="mb-2"
              name="modal-required-doc-active"
              value="0"
            >
              لا
            </b-form-radio>
          </div>
        </b-form-group>
        <div class="d-flex align-items-center justify-content-center">
          <b-button variant="primary" :disabled="invalid || isSubmitting" type="submit">
            <span class="font-size-18 px-5">{{ isSubmitting ? 'جاري الإضافة...' : 'اضافة' }}</span>
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { core } from '@/config/pluginInit'
import transportationServices from '@/modules/transportation/services/transportation'

export default {
  name: 'requirementsModal',
  props: {
    documentType: {
      type: String,
      default: 'company'
    }
  },
  data () {
    return {
      nameAr: '',
      nameEn: '',
      status: '1',
      isSubmitting: false
    }
  },
  methods: {
    trimFields () {
      this.nameAr = (this.nameAr || '').trim()
      this.nameEn = (this.nameEn || '').trim()
    },
    buildTranslations () {
      return [
        { lang: 'ar', name: this.nameAr },
        { lang: 'en', name: this.nameEn }
      ]
    },
    async onSubmit () {
      this.trimFields()
      await this.$nextTick()
      const isValid = await this.$refs.requiredDocForm.validate()
      if (!isValid) {
        return
      }
      const type = this.documentType === 'driver' ? 'driver' : 'company'
      this.isSubmitting = true
      transportationServices.addRequiredDocument({
        type,
        status: String(this.status),
        translations: this.buildTranslations()
      }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.$router.push({ name: 'companiesSettings' })
      }).catch(() => {
        core.showSnackbar('error', 'حدث خطأ أثناء الإضافة، يرجى المحاولة مرة أخرى')
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped>
.required-doc-active-row {
  gap: 15px;
}
</style>
